import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import UnitOfMeasureType from "../../enums/UnitOfMeasureType";
const ConsignmentFreightSummaryTable = ({ freight, className }) => {
    let total = 0;
    const freightRows = freight.map(f => {
        const uom = f.netUnitOfMeasure || f.unitOfMeasure;
        const qty = f.cubicToTonneConvertedQty ? f.orderedQuantity : (f.netQuantity || f.orderedQuantity);
        total += qty;
        return (_jsxs("tr", { children: [_jsx("td", { children: f.productDescription }), _jsxs("td", { style: { textAlign: "right" }, children: [qty, UnitOfMeasureType.valueOf(uom)?.shortDescription] })] }, "freightId" + f.id));
    });
    return (_jsx("table", { className: className, children: _jsx("tbody", { children: freightRows }) }));
};
export default ConsignmentFreightSummaryTable;
